/* eslint-disable unused-imports/no-unused-vars */
import MenuIcon from '@mui/icons-material/Menu';
import { Box, IconButton, styled, useMediaQuery } from '@mui/material';
import dynamic from 'next/dynamic';

import { WelcomeGreatingIcon } from '@/src/shared/assets/WelcomeGreatingIcon';
import { mediumScreen } from '@/src/shared/constants/MediaQueryConstants';
import { useAppRoute } from '@/src/shared/hooks/useAppRoute';
import { BlackWithAlpha } from '@/src/styles/theme/lightThemeOptions';

import { AppHeaderContainer } from '../layouts/style';
import { GreatingPopover, useGreatingtPopover } from './GreatingPopver/GreatingPopover';
import { Logo } from './Logo';

const ClientUserMenu = dynamic(() => import('./UserMenu'), {
    ssr: false,
});

const LogoWrapperBox = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    '@media(max-width: 1024px)': {
        justifyContent: 'center',
        position: 'absolute',
        top: '8px',
        left: '20px',
        right: 0,
    },
});

export const Header = ({ isadmin = false, open = false, handleToggleSideNav }: any) => {
    const { isHomePage } = useAppRoute();
    const isTabScreen: boolean = useMediaQuery(mediumScreen);
    const { greatingPopoverAnchorEl, openGreatingtPopover, closeGreatingtPopover } =
        useGreatingtPopover();

    return (
        <AppHeaderContainer isadmin={isadmin.toString()} data-testid="ginger_header">
            <Box style={{ display: 'flex' }}>
                {isTabScreen && isadmin ? (
                    <IconButton
                        color="inherit"
                        aria-label="menu"
                        style={{ display: 'hidden' }}
                        onClick={handleToggleSideNav}
                    >
                        <MenuIcon />
                    </IconButton>
                ) : null}
                <LogoWrapperBox>
                    <Logo />
                    {isHomePage && (
                        <IconButton onClick={openGreatingtPopover} sx={{ mb: '8px' }}>
                            <WelcomeGreatingIcon
                                sx={{
                                    width: 40,
                                    height: 40,
                                    boxShadow: `
                                        0px 0px 2px 0px ${BlackWithAlpha(0.1216)},
                                        0px 8px 16px 0px ${BlackWithAlpha(0.1412)}
                                    `,
                                    borderRadius: '50%',
                                    border: greatingPopoverAnchorEl
                                        ? '2px solid orange'
                                        : '2px solid transparent',
                                    '&:hover': {
                                        border: '2px solid orange',
                                    },
                                }}
                            />
                        </IconButton>
                    )}
                </LogoWrapperBox>
            </Box>
            <GreatingPopover
                open={!!greatingPopoverAnchorEl}
                anchorEl={greatingPopoverAnchorEl}
                onClose={closeGreatingtPopover}
            />
            <ClientUserMenu isadmin={isadmin} />
        </AppHeaderContainer>
    );
};
